import { httpClient } from '@/services/http/httpClient'

export type AddResponsible = {
  projectId: string
  responsibleId: string
}

export async function addResponsible({
  projectId,
  responsibleId,
}: AddResponsible) {
  await httpClient.post(
    `/projects/project-invites/add-responsible/${projectId}`,
    {
      responsibleId,
    },
  )
}
